import axios from "axios";


const instance = axios.create({
    baseURL: "https://api.themoviedb.org/3",
});

// if instance.get('/some url') is called. 
//It will return "https://api.themoviedb.org/3/some url"


export default instance;